import styles from './style.module.css';
import { Title } from '@plataformaxvia/design-system';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import { IoMdPin } from 'react-icons/io';
import { FaRegCalendar, FaPhoneAlt } from 'react-icons/fa';


export interface DepartmentSections {
  id: string;
  name: string;
  address?: string;
  postalCode?: string;
  district?: string;
  city?: string;
  state?: string;
  countryCode?: string;
  openingTime?: string;
  mapUrl?: string;
  active?: boolean;
  complement?: string;
  contact?: string;
}

export interface SectionLocationProps {
  section: DepartmentSections;
  mapUrl?: string;
}

export const SectionLocation = ({
  section,
  mapUrl,
}: SectionLocationProps) => {
  return (
    <div className={styles.cardBaseLocation}>
      <div className={styles.baseLocation}>
        <Title title={"Local de Atendimento"} as={'h2'} />
      </div>
      <>
        {mapUrl && (
          <div className={styles.locationMap}>
            <iframe
              src={mapUrl}
              title={`Mapa da localização da unidade ${section.name}`}
              aria-label={`Mapa da localização da unidade ${section.name}`}
              width="100%"
              height="220px"
              className={styles.map}
            />
          </div>
        )}
        <div className={styles.baseAddress}>
          <div className={styles.department}>{section.name}</div>
          <div className={styles.wrapAddress}>
            <span role="img" aria-label="Ícone de localização">
              <LocationOnOutlinedIcon className={styles.icon} fontSize={"small"} />
            </span>
            <div>
              <div className={styles.subTitle}>Endereço</div>
              <div className={styles.typography}>
                {section.address},
                {section.complement ? ` ${section.complement},` : ''}{' '}
                {section.district}, {section.city} / {section.state},{' '}
                {`CEP: ${section.postalCode}`}
              </div>
            </div>
          </div>
          {section.openingTime && (
            <div className={styles.wrapAddress}>
              <span role="img" aria-label="Ícone de calendário">
                <CalendarTodayOutlinedIcon className={styles.icon} fontSize={"small"} />
              </span>
              <div>
                <div className={styles.subTitle}>Horário de atendimento</div>
                <div className={styles.typography}>{section.openingTime}</div>
              </div>
            </div>
          )}
          {section.contact && (
            <div className={styles.wrapAddress}>
              <span role="img" aria-label="Ícone de telefone">
                <PhoneOutlinedIcon className={styles.icon} fontSize={'small'} />
              </span>
              <div>
                <div className={styles.subTitle}>Telefone para contato</div>
                <div className={styles.typography}>
                  {section.contact}
                </div>
              </div>
            </div>
          )}
        </div>
      </>
    </div>
  );
};
